const csvUtil = {
  sanitizeFilename (filename?: string) {
    if (!filename) return ''
    let sanitized = filename.split('/').pop()
    sanitized = sanitized ? sanitized.replace('.csv', '') : ''
    return `${sanitized}.csv`
  }
}

export default csvUtil
